// Mapa central de rótulos PT-BR para campos de Workshift / WorkshiftDay /
// WorkshiftDayPhase / CompanySettings. Usado por todas as telas novas de
// configuração de turnos, fases, HE3, fuso e regras de saldo.

export const workShiftLabels = {
  // WorkShift
  code: "Código",
  name: "Nome do turno",
  workShiftType: "Tipo de turno",
  timeZone: "Fuso do turno",
  isFlexible: "Turno flexível",
  ignoreHoliday: "Ignora feriado",
  intervalMarked: "Intervalo marcado",
  useNightshiftPhase: "Usa fase noturna",
  nightshiftIInit: "Início fase noturna",
  nightshiftIEnd: "Fim fase noturna",
  remunerateType: "Tipo de remuneração",
  extraordinaryPhase: "Fase extraordinária (HE3)",
  toleranceType: "Tipo de tolerância",
  toleranceValues: "Valores de tolerância",
  applyPercentagesToBalance: "Aplica percentuais ao saldo",
  firstPeriodTimePercent: "% 1º período",
  secondPeriodTimePercent: "% 2º período",
  thirdPeriodTimePercent: "% 3º período",
  applyRecalcPoints: "Recalcula pontos automaticamente",
  // Configurações avançadas do turno
  hasNoCompensatoryCalculation: "Não compensatório",
  ignoreNightshiftWhenHasNocturnalExtra: "Ignorar adicional noturno quando houver hora extra noturna",
  notifyWhenExtraHours: "Notificar quando houver hora extra",
  notifyExtraHoursInMinutes: "Tolerância para notificar hora extra (min)",
  notifyWhenHasNoInterval: "Notificar quando não houver intervalo",
  notifyHasNoIntervalInMinutes: "Tolerância para notificar ausência de intervalo (min)",
  notifyWhenWorkscheduleChange: "Notificar quando a escala mudar",
  pointTolerance: "Tolerância (min)",
};

export const workShiftDayLabels = {
  dayOfWeek: "Dia da semana",
  workingDayTotal: "Carga horária do dia",
  entryTime: "Entrada",
  exitTime: "Saída",
  firstPeriodDuration: "Duração do 1º período",
  firstPeriodTimePercent: "% 1º período",
  secondPeriodTimePercent: "% 2º período",
  isActive: "Dia ativo",
};

export const workshiftDayPhaseLabels = {
  workshiftDayPhaseType: "Tipo de dia",
  isActive: "Fase ativa",
  firstPhaseDuration: "Duração 1ª Fase",
  secondPhaseDuration: "Duração 2ª Fase",
  thirdPhaseDuration: "Duração 3ª Fase",
  fourthPhaseDuration: "Duração 4ª Fase",
  applyFirstPercentageToBalance: "1ª Fase entra no saldo",
  applySecondPercentageToBalance: "2ª Fase entra no saldo",
  applyThirdPercentageToBalance: "3ª Fase entra no saldo",
  applyFourthPercentageToBalance: "4ª Fase entra no saldo",
  addIntervalToTotalPlus: "Soma intervalo no saldo positivo",
};

export const companySettingsLabels = {
  defaultTimeZone: "Fuso padrão da empresa",
  useExtraNight: "HE3 (noturna) ativa",
  extraNightInit: "Início HE3",
  extraNightEnd: "Fim HE3",
  extraordinaryPhase: "Fase extraordinária (HE3)",
  applyPercentagesToBalance: "Aplica percentuais ao saldo",
  remunerateType: "Tipo de remuneração",
  toleranceType: "Tipo de tolerância",
  ignoreMissingHoursOnFault: "Ignora horas faltantes em falta",
  applyNightShiftPhaseWhenHasAbono: "Aplica fase noturna em abono",
  firstPeriodTimePercent: "% 1º período",
  secondPeriodTimePercent: "% 2º período",
  thirdPeriodTimePercent: "% 3º período",
  applyRecalcPoints: "Recalcula pontos automaticamente",
};

// EWorkshiftDayPhaseType (enum backend)
export const workshiftDayPhaseTypeLabels = {
  0: "Domingo",
  1: "Segunda-Feira",
  2: "Terça-Feira",
  3: "Quarta-Feira",
  4: "Quinta-Feira",
  5: "Sexta-Feira",
  6: "Sábado",
  7: "Feriado",
  8: "Folga",
  9: "Trabalho Ciclo",
  10: "Folga Ciclo",
  11: "Folga e Feriado",
};

// EWorkShiftType
export const workShiftTypeLabels = {
  0: "Não informado",
  1: "Semanal",
  2: "Cíclico",
  3: "Livre",
  4: "Escala",
};

// EExtraordinaryPhase (HE3)
export const extraordinaryPhaseLabels = {
  0: "Nenhum",
  1: "Feriado",
  2: "Domingo",
  3: "Domingo e Feriado",
  4: "3ª fase em fins de semana e feriados",
  5: "3ª fase em domingos e feriados",
  6: "Fins de semana e feriados",
  7: "2ª aos sábados, 3ª domingos e feriados",
  8: "3ª fase aos feriados",
  9: "3ª fase em fins de semana e feriados (2 fases)",
  10: "Apenas 1ª fase no saldo (com 2ª e 3ª)",
  11: "2ª fase domingo/feriado sem saldo",
  12: "1ª no saldo, 2ª sábados, 3ª domingos/feriados",
  13: "2ª feriados, 3ª domingos",
  14: "2ª seg-sáb e feriados, 3ª domingos",
};

// EToleranceType (enum backend) — descrições espelhadas de EToleranceType.cs
export const toleranceTypeLabels = {
  0: "Não aplicar",
  1: "Cada registro",
  2: "Acumulada no dia",
  3: "Cada registro e acumulada no dia",
  4: "Acumulada no dia (Youtility)",
  5: "Primeiro ponto e último",
  6: "Entrada e saída fixo, intervalo flexível",
};

// Helpers de formatação para exibição.
export const labelHelpers = {
  // "23:59:00" / "00:00:00" / null -> "23:59" / "—"
  formatTimeSpan(value) {
    if (value === null || value === undefined || value === "") return "—";
    const parts = String(value).split(":");
    if (parts.length < 2) return value;
    return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}`;
  },

  formatBool(value) {
    if (value === true) return "Sim";
    if (value === false) return "Não";
    return "—";
  },

  // null = herda da empresa (M3)
  formatInheritableTimezone(workshiftTz, companyTz) {
    if (workshiftTz && workshiftTz.length > 0) return workshiftTz;
    return companyTz ? (companyTz + " (herdado)") : "—";
  },

  // Recebe o nome técnico (Windows TZ ID, ex: "E. South America Standard Time")
  // e um dicionário { winName: "(GMT -03:00) Brasília" } (retornado pelo
  // endpoint GET_TIMEZONE_LIST). Devolve o label amigável quando encontra,
  // ou cai pro próprio nome quando não. Usar quando a UI mostra o fuso pro
  // operador (lista de turnos, detalhe, etc.).
  formatTimezoneFriendly(windowsName, lookup) {
    if (!windowsName) return "—";
    if (lookup && lookup[windowsName]) return lookup[windowsName];
    return windowsName;
  },

  // Versão que respeita herança (null/vazio = herda da empresa) e aplica o
  // lookup amigável. Substitui formatInheritableTimezone quando o caller
  // tem o dicionário do GET_TIMEZONE_LIST disponível.
  formatInheritableTimezoneFriendly(workshiftTz, companyTz, lookup) {
    if (workshiftTz && workshiftTz.length > 0) {
      return labelHelpers.formatTimezoneFriendly(workshiftTz, lookup);
    }
    if (!companyTz) return "—";
    return labelHelpers.formatTimezoneFriendly(companyTz, lookup) + " (herdado)";
  },

  // null = herda da empresa (M5)
  formatInheritableBool(workshiftValue, companyValue) {
    if (workshiftValue === true) return "Sim";
    if (workshiftValue === false) return "Não";
    return labelHelpers.formatBool(companyValue) + " (herdado)";
  },

  // Resolve label por chave em qualquer um dos mapas acima
  getLabel(field) {
    return (
      workShiftLabels[field] ||
      workShiftDayLabels[field] ||
      workshiftDayPhaseLabels[field] ||
      companySettingsLabels[field] ||
      field
    );
  },

  getPhaseTypeLabel(value) {
    return workshiftDayPhaseTypeLabels[value] || ("Tipo " + value);
  },

  getWorkShiftTypeLabel(value) {
    return workShiftTypeLabels[value] || ("Tipo " + value);
  },

  getExtraordinaryPhaseLabel(value) {
    return extraordinaryPhaseLabels[value] || ("Fase " + value);
  },

  getToleranceTypeLabel(value) {
    if (value === undefined || value === null) return "—";
    return toleranceTypeLabels[value] || ("Tolerância " + value);
  },
};

export default {
  workShiftLabels,
  workShiftDayLabels,
  workshiftDayPhaseLabels,
  companySettingsLabels,
  workshiftDayPhaseTypeLabels,
  workShiftTypeLabels,
  extraordinaryPhaseLabels,
  toleranceTypeLabels,
  labelHelpers,
};



// WEBPACK FOOTER //
// ./src/labels/workshiftLabels.js